import React from 'react';
import {

  Check,
  Star,
  ShieldCheck,
  User,
  BookOpen,
  Clock,
  Wifi,
  Award,
} from 'lucide-react';
import BotaoUrgencia from './BotaoUrgencia';
import ExitIntent from './ExitIntent';

const App = () => {
  const comentarios = [
    { name: "Ana Clara Silva", time: "Há 2 horas", txt: "Gente, funciona mesmo? Tenho medo de gastar e não dar certo." },
    { name: "Marcos Mendes", time: "Há 3 horas", txt: "Pode comprar sem medo, Ana. Mudou minha vida em 3 dias. A parte dos minerais faz total sentido." },
    { name: "Lucas Ferreira", time: "Há 5 horas", txt: "Impressionante como o gosto ruim na boca sumiu de manhã." },
    { name: "Pedro Gomes", time: "Há 12 horas", txt: "O preço tá ridículo de barato pelo que entrega. Valeu cada centavo." },
  ];

  const listaConteudo = [
    "Saber a verdadeira origem de seu mau hálito.",
    "Conhecer todos os tipos de mau hálito e suas causas.",
    "Técnicas validadas de remoção mecânica e química das bactérias.",
    "Alimentos bons e maus para seu hálito.",
    "Probióticos e suplementos para combate e prevenção.",
    "Estratégias de hidratação e estilo de vida.",
  ];

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800">
      {/* Top Bar */}
      <div className="bg-slate-900 text-center py-3 px-4 shadow-md sticky top-0 z-50">
        <h1 className="text-white font-extrabold tracking-widest text-lg md:text-xl uppercase">
          Portal do Hálito <span className="text-blue-400">Blindado</span>
        </h1>
      </div>

      {/* Hero Section */}
      <section className="max-w-4xl mx-auto px-4 pt-8 pb-12">
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-4xl font-extrabold leading-tight mb-4">
            PESQUISADOR, AUTOR E DENTISTA BRASILEIRO REVELA O PROTOCOLO DE 3 FASES PARA ELIMINAR O MAU HÁLITO <span className="text-red-600 bg-red-100 px-1 rounded">DEFINITIVAMENTE</span>, EM ATÉ 14 DIAS
          </h1>
          <p className="text-slate-600 text-sm md:text-base">
            Um estudo diferente revela por que seu hálito ainda tem cheiro ruim, mesmo que você escove os dentes 5 vezes ao dia.
          </p>
          <div className="flex justify-center items-center gap-2 mt-2 text-xs text-slate-400">
            <span>Por DR. Ivo | Hálito Blindado</span>
            <span>•</span>
            <span>Atualizado: Hoje</span>
          </div>
        </div>

        {/* Hero Image (estática) */}
        <div className="rounded-xl overflow-hidden shadow-2xl border-4 border-white mb-3">
          <img
            src="https://portal.halitoblindado.com.br/entrevistagma.png"
            alt="Dr. Ivo em destaque"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="text-center text-sm text-slate-700 mb-8">
          <p className="font-semibold">Acabe com o Mau hálito: Médico odontologista Ivo Corrêa revela método para eliminar a Halitóse pela raiz.</p>
          <p className="text-xs text-slate-500 mt-1">Reprodução: Youtube | Good Moning America</p>
        </div>

        {/* CTA 1 */}
        <div className="text-center mb-12">
          <BotaoUrgencia />
        </div>

        {/* Problem Section */}
        <div className="space-y-8 text-left">
          <div>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 uppercase">Sua boca é uma bomba-relógio social e você sabe disso</h2>
            <p className="mb-4 text-slate-700 leading-relaxed">
              Talvez você já tenha passado pela vergonha de ver alguém oferecendo uma bala de menta no meio de uma conversa. Ou pior, ver as pessoas dando um passo para trás quando você fala.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Você vive em um estado de paranoia constante. "Será que meu hálito está ruim agora?". Esse medo te impede de ser espontâneo e pode estar custando aquela promoção ou aquele relacionamento.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 uppercase">A CAUSA REAL: SUA BOCA VIROU UMA "FÁBRICA DE LIXO"</h2>
            <p className="mb-4 text-slate-700">
              O que o Dr. Ivo descobriu é que o seu problema é uma infecção de bactérias gram-negativas, como por exemplo:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-slate-800 font-semibold">
              <li><span className="bg-yellow-200 px-1">Porphyromonas gingivalis</span></li>
              <li><span className="bg-yellow-200 px-1">Fusobacterium nucleatum</span></li>
              <li><span className="bg-yellow-200 px-1">Streptococcus gordonii</span></li>
              <li><span className="bg-yellow-200 px-1">Prevotella intermedia</span></li>
              <li><span className="bg-yellow-200 px-1">Treponema denticola</span></li>
              <li><span className="bg-yellow-200 px-1">Tannerella forsythia</span></li>
            </ul>
            <p className="mt-4 text-slate-700">
              São super-bactérias que se alimentam de resíduos da sua língua e soltam no ar o que há de pior: Gás de Enxofre.
            </p>

            <div className="border border-gray-200 rounded-xl p-5 mt-6 bg-gray-50">
              <span className="text-red-600 font-bold text-xl block mb-2">G1</span>
              <h3 className="text-xl font-bold text-gray-900 leading-tight mb-2">PESQUISA REVELA: Bactéria 'escondida' na língua libera gás com cheiro de fezes, dizem cientistas.</h3>
              <p className="text-gray-600 text-sm m-0">Estudo aponta que compostos de enxofre (CSV) são a real causa do mau hálito crônico, e não o estômago.</p>
            </div>
          </div>

          {/* Scientific Section */}
          <div className="bg-slate-900 text-white p-6 md:p-8 rounded-2xl shadow-xl my-10 border border-slate-700 relative overflow-hidden">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-blue-500 rounded-full blur-2xl opacity-20"></div>

            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-blue-300 border-b border-slate-700 pb-4">
              A CIÊNCIA POR TRÁS: ESTUDOS DA UNIVERSIDADE DE XANGAI
            </h2>

            <div className="space-y-4 text-slate-300 leading-relaxed">
              <p>
                O <strong className="text-white">Método Hálito Blindado</strong> foi desenvolvido através de estudos profundos realizados na renomada Universidade de Xangai.
              </p>
              <p>
                Descobriu-se que <strong className="text-yellow-400">minerais raros extraídos de conchas da Costa Leste</strong>, usados por séculos na medicina oriental para a purificação bucal, possuem propriedades únicas quando associados a tecnologia moderna.
              </p>
              <p>
                No método, esses minerais foram associados a <strong className="text-white">compostos estabilizantes de liberação lenta</strong>. Essa combinação age na eliminação das bactérias anaeróbicas (geradoras de gases sulfurosos), ao mesmo tempo em que atua na neutralização imediata dos odores dos <strong className="text-yellow-400">Compostos Sulfurados Voláteis (CSV)</strong>, os verdadeiros vilões do mau cheiro.
              </p>
            </div>
          </div>

          {/* Triade Terapêutica */}
          <div className="bg-white p-6 rounded-xl shadow-lg border border-slate-200 mb-10">
            <h3 className="text-xl font-bold text-slate-800 mb-6 uppercase border-b pb-2">A Tríade Terapêutica: 3 Frentes de Ataque</h3>
            <div className="space-y-4">
              {[
                { step: "1", title: "HIGIENIZAÇÃO QUÍMICA (QUE MATA 99%)", desc: "Acaba com a 'colônia' de bactérias na região da orofaringe." },
                { step: "2", title: "REESTRUTURAÇÃO DA SALIVA (PH NEUTRO)", desc: "Estimula a produção de saliva de qualidade que protege a boca." },
                { step: "3", title: "DETOX SISTÊMICO (DE DENTRO PRA FORA)", desc: "Limpa o organismo de toxinas que causam o hálito estomacal." },
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-md">
                    {item.step}
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm md:text-base">{item.title}</h4>
                    <p className="text-xs md:text-sm text-slate-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* New Section: O que você vai receber (Product Delivery) */}
          <div className="bg-blue-50 p-6 md:p-8 rounded-2xl shadow-inner border border-blue-100 my-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-2 uppercase">
                O Que Você Vai Receber
              </h2>
              <p className="text-slate-600">Um treinamento completo, 100% online, dividido em 5 módulos estratégicos</p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="space-y-4">
                <h3 className="font-bold text-blue-800 text-lg flex items-center gap-2">
                  <BookOpen className="w-5 h-5" /> Conteúdo dos Módulos:
                </h3>
                <ul className="space-y-3">
                  {listaConteudo.map((item, i) => (
                    <li key={i} className="flex items-start gap-3 bg-white p-3 rounded-lg shadow-sm border border-blue-100">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-slate-700 font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex flex-col justify-between space-y-4">
                <div className="bg-white p-5 rounded-xl border border-blue-200 shadow-sm">
                  <h4 className="font-bold text-slate-900 mb-2 flex items-center gap-2">
                    <Award className="w-5 h-5 text-yellow-500" /> Seu Passaporte da Liberdade
                  </h4>
                  <p className="text-sm text-slate-600 mb-4">
                    No método você receberá toda a composição para ser utilizada no seu tratamento e na manutenção de hálito saudável. É o seu passaporte para conviver em sociedade sem medo de ser discriminado.
                  </p>
                </div>

                <div className="bg-blue-600 text-white p-5 rounded-xl shadow-md">
                  <h4 className="font-bold mb-3 flex items-center gap-2">
                    <Wifi className="w-5 h-5" /> Entrega 100% Online
                  </h4>
                  <ul className="space-y-2 text-sm text-blue-100">
                    <li className="flex items-center gap-2"><Clock size={16} /> Poucos minutos por dia de dedicação</li>
                    <li className="flex items-center gap-2"><Check size={16} /> Realize em casa ou no trabalho</li>
                    <li className="flex items-center gap-2"><User size={16} /> Suporte completo ao aluno</li>
                  </ul>
                  <p className="mt-4 text-xs italic opacity-80 border-t border-blue-500 pt-2">
                    Cada módulo será entregue em uma sequência lógica que te levará à reconquista de sua liberdade, passo a passo.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Author */}
          <div className="flex items-center gap-4 bg-slate-100 p-4 rounded-lg">
            <div className="w-16 h-16 bg-slate-300 rounded-full overflow-hidden flex-shrink-0">
              <img src="https://portal.halitoblindado.com.br/ivo.png" alt="Autor" className="w-full h-full object-cover" />
            </div>
            <div>
              <h4 className="font-bold text-slate-900">Sobre o Autor</h4>
              <p className="text-xs text-slate-600">
                Dr. Ivo é especialista em halitose e dedicou os últimos 10 anos a criar protocolos simples para eliminar o mau hálito sem produtos químicos agressivos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="bg-white py-12 border-t border-slate-200">
        <div className="max-w-4xl mx-auto px-4">
          <h3 className="text-center font-bold text-2xl mb-8">Veja quem já transformou sua vida</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {[
              {
                name: "Gabriela",
                age: "27 anos",
                title: "Comprou para o marido e acabou com o constrangimento. 'Foi o melhor presente que já dei para nossa relação.'",
                color: "bg-pink-50",
                videoId: "-s1I_KbbzwM"
              },
              {
                name: "Gustavo",
                age: "44 anos",
                title: "Professor, quase perdeu a carreira por medo de falar perto. Hoje, voltou a dar aulas com confiança total.",
                color: "bg-blue-50",
                videoId: "4BgZ_4VGcco"
              },
            ].map((person, i) => (
              <div key={i} className={`${person.color} p-4 rounded-xl shadow-sm border border-slate-100`}>
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex text-yellow-400">
                    <Star size={16} fill="currentColor" />
                    <Star size={16} fill="currentColor" />
                    <Star size={16} fill="currentColor" />
                    <Star size={16} fill="currentColor" />
                    <Star size={16} fill="currentColor" />
                  </div>
                  <span className="text-xs text-slate-500 font-semibold">Verificado</span>
                </div>
                <h4 className="font-bold text-slate-800 mb-3">"{person.title}"</h4>
                <div className="aspect-[9/16] rounded-lg relative overflow-hidden bg-slate-900">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${person.videoId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title={`Depoimento de ${person.name}`}
                    className="absolute inset-0 w-full h-full"
                  ></iframe>
                </div>
                <div className="mt-2 text-xs font-bold text-slate-500 uppercase tracking-wide">
                  Depoimento de {person.name}
                </div>
              </div>
            ))}
          </div>

          {/* Comments */}
          <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
            <h4 className="text-sm font-bold text-slate-600 mb-4 border-b pb-2">Comentários recentes (127)</h4>
            <div className="space-y-4">
              {comentarios.map((c, i) => (
                <div key={i} className="flex gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-300 flex items-center justify-center text-slate-500 font-bold">
                    {c.name.charAt(0)}
                  </div>
                  <div className="bg-white p-3 rounded-2xl rounded-tl-none shadow-sm flex-1">
                    <p className="font-bold text-slate-900 text-sm">{c.name}</p>
                    <p className="text-slate-700 text-sm">{c.txt}</p>
                    <div className="flex gap-4 mt-2 text-xs text-slate-500 font-semibold">
                      <span className="cursor-pointer hover:underline text-blue-600">Curtir</span>
                      <span className="cursor-pointer hover:underline text-blue-600">Responder</span>
                      <span>{c.time}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Offer Section */}
      <section id="oferta" className="py-12 bg-slate-900 text-white text-center px-4">
        <div className="max-w-2xl mx-auto border-2 border-yellow-400 p-6 md:p-10 rounded-2xl bg-gradient-to-b from-slate-800 to-slate-900 shadow-2xl relative">

          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide shadow-lg whitespace-nowrap">
            OFERTA POR TEMPO LIMITADO
          </div>

          <h3 className="text-2xl md:text-3xl font-bold mb-4 mt-4">
            Tenha acesso ao Método Completo + 3 Bônus Exclusivos
          </h3>

          <p className="text-slate-400 mb-8">
            Você não vai pagar o preço original de consultoria. Garanta sua vaga com o desconto de lançamento.
          </p>

          <div className="mb-6 text-slate-200 text-sm font-semibold">
            De R$ 717,90 por R$ 147,00 · 12x de R$ 12,25
          </div>

          {/* Bônus incluídos */}
          <div className="rounded-2xl p-5 mb-6 bg-white/8 border border-white/10 shadow-inner backdrop-blur text-left space-y-3">
            {[
              { titulo: 'Bônus 1: Guia Anti-Fermentação', de: 'R$ 59,90', icon: <Check className="w-5 h-5 text-emerald-300" /> },
              { titulo: 'Bônus 2: O Jantar do Beijo', de: 'R$ 67,00', icon: <Check className="w-5 h-5 text-emerald-300" /> },
              { titulo: 'Bônus 3: Manual Fale de Perto', de: 'R$ 97,00', icon: <Check className="w-5 h-5 text-emerald-300" /> },
              { titulo: 'Grupo VIP de Apoio', de: 'R$ 197,00', icon: <ShieldCheck className="w-5 h-5 text-sky-300" /> },
            ].map((item, idx) => (
              <div key={idx} className="flex items-center justify-between gap-3 rounded-xl px-4 py-3 bg-white/5 border border-white/10">
                <div className="flex items-center gap-3 text-left">
                  <span className="shrink-0">{item.icon}</span>
                  <span className="font-semibold text-sm text-white">{item.titulo}</span>
                </div>
                <div className="flex items-center gap-2 text-xs font-semibold">
                  <span className="line-through text-slate-300/70">{item.de}</span>
                  <span className="bg-emerald-100 text-emerald-700 px-2 py-1 rounded-full shadow-sm">GRÁTIS</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-4">
            <BotaoUrgencia />
          </div>

          <div className="mt-4 flex justify-center items-center gap-4 text-xs text-slate-400">
            <span className="flex items-center gap-1"><ShieldCheck size={14} /> Compra Segura</span>
            <span className="flex items-center gap-1"><Check size={14} /> Satisfação Garantida</span>
            <span className="flex items-center gap-1"><ShieldCheck size={14} /> Privacidade Protegida</span>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-500 py-8 text-center text-xs px-4">
        <div className="max-w-4xl mx-auto space-y-4">
          <p>Hálito Blindado © {new Date().getFullYear()} - Todos os direitos reservados.</p>
          <div className="flex justify-center gap-4">
            <span className="cursor-pointer hover:text-white">Termos de Uso</span>
            <span className="cursor-pointer hover:text-white">Políticas de Privacidade</span>
            <span className="cursor-pointer hover:text-white">Contato</span>
          </div>
          <p className="max-w-2xl mx-auto opacity-60">
            Este site não faz parte do site do Facebook ou Facebook Inc. Além disso, este site NÃO é endossado pelo Facebook de nenhuma maneira. FACEBOOK é uma marca comercial da FACEBOOK, Inc. Os resultados podem variar de pessoa para pessoa.
          </p>
        </div>
      </footer>
      <ExitIntent />
    </div>
  );
};

export default App;
